import { AllFilters, FiltersMap, FiltersValues } from '@wix/bex-core';
import { InfoIconProps } from '@wix/design-system';

export type ColumnSortDirection = 'Ascending' | 'Descending';

export const columnSortDirection = {
  Ascending: 'Ascending' as const,
  Descending: 'Descending' as const,
};

export interface ColumnViewConfig {
  id: string;
  name?: string;
  isSelected?: boolean;
}

export interface ColumnSortConfig {
  columnId: string;
  direction: ColumnSortDirection;
}

export interface BasicCategory {
  id: string;
  name: string;
  info?: InfoIconProps;
}

export interface Category<F extends FiltersMap> extends BasicCategory {
  id: string;
  views: View<F>[];
}

export interface ViewBase<F extends FiltersMap> {
  filters?: Partial<FiltersValues<AllFilters<F>>>;
  orderedColumns?: ColumnViewConfig[];
  selectedColumns?: ColumnViewConfig[];
  sortDirections?: ColumnSortConfig[];
}

export interface View<F extends FiltersMap> extends ViewBase<F> {
  id: string;
  name: string;
  isDefaultView?: boolean;
  /** @deprecated: deletion of predefined views will soon stop to be supported */
  isDeletable?: boolean;
  createdAt?: string;
}

export type AllItemsViewProps<F extends FiltersMap> = Omit<
  View<F>,
  'id' | 'createdAt' | 'filters' | 'isDefaultView' | 'isDeletable' | 'name'
> & {
  /** A label to show instead of default 'All Items' */
  name?: string;

  /** Hides 'All Items' view from the list, default: false. Will be ignored if no presets are passed. */
  hidden?: boolean;
};

export type ViewActionNameBI =
  | 'view-save-changes'
  | 'view-save-new'
  | 'view-rename'
  | 'view-delete'
  | 'view-set-as-default'
  | 'view-unset-as-default';

export type PrivateView<F extends FiltersMap> = View<F> & {
  categoryId?: string;
  categorySortInd: string;
  isPreset: boolean;
};

export interface ViewsDTO<F extends FiltersMap> {
  hiddenPresetIds?: string[];
  views?: View<F>[];
}

export const ALL_ITEMS_VIEW_ID = 'all-items-view';
export const SAVED_VIEWS_ID = 'saved-views';
export const PREDEFINED_VIEWS_ID = 'predefined-views';

export const ALL_ITEMS_SORT_IND = '0';
export const SAVED_VIEWS_SORT_IND = '1';
export const PREDEFINED_VIEWS_SORT_IND = '2';
